module.exports = `${require.publicPath}1@2x.257011b3.png`;